import { render, staticRenderFns } from "./companyMerchantNetUpdates.vue?vue&type=template&id=08ae2e5e&scoped=true&"
import script from "./companyMerchantNetUpdates.vue?vue&type=script&lang=js&"
export * from "./companyMerchantNetUpdates.vue?vue&type=script&lang=js&"
import style0 from "./companyMerchantNetUpdates.vue?vue&type=style&index=0&id=08ae2e5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae2e5e",
  null
  
)

export default component.exports